var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5865 14.1844L11.5541 12.152C11.0912 12.3171 10.5927 12.407 10.0731 12.407C7.63919 12.407 5.66612 10.4339 5.66612 8C5.66612 7.48045 5.75603 6.98189 5.92113 6.51904L3.32553 3.92344C1.18197 5.83305 0 8 0 8C0 8 3.77741 14.9253 10.0731 14.9253C11.3516 14.9253 12.5263 14.6397 13.5865 14.1844Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55969 1.81554C7.61995 1.36034 8.7946 1.07474 10.0731 1.07474C16.3688 1.07474 20.1462 8 20.1462 8C20.1462 8 18.9642 10.1669 16.8207 12.0765L14.2251 9.48093C14.3902 9.01809 14.4801 8.51954 14.4801 8C14.4801 5.56609 12.507 3.59302 10.0731 3.59302C9.55356 3.59302 9.05502 3.68292 8.59218 3.84802L6.55969 1.81554Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95655 7.55446C6.93592 7.70001 6.92526 7.84876 6.92526 8C6.92526 9.73851 8.3346 11.1478 10.0731 11.1478C10.2243 11.1478 10.3731 11.1372 10.5186 11.1166L6.95655 7.55446Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1897 8.44551L9.62759 4.88344C9.77313 4.86282 9.92187 4.85215 10.0731 4.85215C11.8116 4.85215 13.2209 6.26149 13.2209 8C13.2209 8.15123 13.2103 8.29997 13.1897 8.44551Z",
    fill: "inherit"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1828 16L2.0731 0.890345L2.96345 0L18.0731 15.1097L17.1828 16Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEyeSlash);
export default __webpack_public_path__ + "static/media/ico-eye_slash.109d628475aa52837423c2fd27f20d5e.svg";
export { ForwardRef as ReactComponent };